import React from "react";

//Components
import Paragraph from "../../Atoms/Paragraph";

// Stylesheets
import "./WhyToBuy.scss";
import { ReactComponent as HappyIcon } from "../../../images/why-buy-happy.svg";
import { ReactComponent as TruckIcon } from "../../../images/why-buy-truck.svg";
import { ReactComponent as WarrantyIcon } from "../../../images/why-buy-warranty.svg";

// Constants
const FEATURE_ICON_LIST = [
  { icon: TruckIcon, label: "Free 2-Day Shipping" },
  { icon: HappyIcon, label: "60-Night Money-Back Guarantee" },
  { icon: WarrantyIcon, label: "1-Year Product Warranty" },
];

export function IconWithLabel({ icon: Icon, label }) {
  return (
    <div className="why-to-buy__label-container">
      <Icon className="why-to-buy__icon" />

      <Paragraph className="label caption_tertiary">{label}</Paragraph>
    </div>
  );
}

const WhyToBuy = () => {
  return (
    <header className="why-to-buy" id={"j-why-to-buy-exists"}>
      <div className="why-to-buy__labels">
        {FEATURE_ICON_LIST.map((props, index) => (
          <IconWithLabel key={index} {...props} />
        ))}
      </div>
    </header>
  );
};

export default WhyToBuy;
